<template>
  <div class="image-text">
    <slot name="text"></slot>
    <slot name="image"></slot>
  </div>
</template>

<script>
export default {
  name: "ImageTextLeftTop",
};
</script>

<style lang="scss" scoped>
.image-text {
  @include mobile {
    flex-direction: column-reverse;
  }

  p {
    flex: 1;
  }

  img {
    flex: 3;
  }
}
</style>
